import React from 'react';

const Label = ({ number }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='56'
      height='20.007'
      viewBox='0 0 56 20.007'
    >
      <path
        className='a'
        d='M56,11.008a4.1,4.1,0,0,0-1.187-2.884L49.2,2.466A5,5,0,0,0,45.628,1H2.811A2.811,2.811,0,0,0,0,3.813V18.19A2.811,2.811,0,0,0,2.811,21H45.628A5,5,0,0,0,49.2,19.536l5.609-5.658A4.062,4.062,0,0,0,56,11.008Zm-4.149,0a1.965,1.965,0,1,1-1.965-1.977,1.971,1.971,0,0,1,1.965,1.977Z'
        transform='translate(0 -0.998)'
        style={{ fill: '#ff6d4a', fillRule: 'evenodd' }}
      />
      <text
        className='b'
        transform='translate(7.017 14.002)'
        style={{
          fill: '#fff',
          fontSize: '11px',
          fontFamily: 'Roboto-Bold, Roboto',
          fontWeight: 700,
          letterSpacing: '0.042em',
        }}
      >
        <tspan x='0' y='0'>
          GIFT {number}
        </tspan>
      </text>
    </svg>
  );
};

export default Label;
